// removed by extract-text-webpack-plugin
module.exports = {"content":"HomeHeader__content__2rhhy","parentContainer":"HomeHeader__parentContainer__8aUtx","header":"HomeHeader__header__2p6Ou","headerHeading":"HomeHeader__headerHeading__1K06C","carousel":"HomeHeader__carousel__px99x","carouselItem":"HomeHeader__carouselItem__2JGrv","carouselItemContentWrapper":"HomeHeader__carouselItemContentWrapper__2xBKZ","carouselItemContent1":"HomeHeader__carouselItemContent1__22YbB","carouselItemContent2":"HomeHeader__carouselItemContent2__1ojtr","headerMenu":"HomeHeader__headerMenu__3UJib"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeHeader/HomeHeader.css
// module id = 1017
// module chunks = 0